// @ts-nocheck
import React from 'react';
import { ApplyPluginsType, dynamic } from '/root/workspace/storagesystem_5dn7/node_modules/@umijs/runtime';
import * as umiExports from './umiExports';
import { plugin } from './plugin';
import LoadingComponent from '@/loadingView';

export function getRoutes() {
  const routes = [
  {
    "path": "/",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'layouts__index' */'@/layouts/index.js'), loading: LoadingComponent}),
    "routes": [
      {
        "path": "/404",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__404' */'@/pages/404.js'), loading: LoadingComponent})
      },
      {
        "path": "/addaccountdetails",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__addaccountdetails__index' */'@/pages/addaccountdetails/index.js'), loading: LoadingComponent})
      },
      {
        "path": "/adjustComplete",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__adjustComplete__index' */'@/pages/adjustComplete/index.js'), loading: LoadingComponent})
      },
      {
        "path": "/adjustStorage",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__adjustStorage__index' */'@/pages/adjustStorage/index.js'), loading: LoadingComponent})
      },
      {
        "path": "/audit",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__audit__index' */'@/pages/audit/index.js'), loading: LoadingComponent})
      },
      {
        "path": "/baseDataManage/materialData/materialType",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__baseDataManage__materialData__materialType__index' */'@/pages/baseDataManage/materialData/materialType/index.js'), loading: LoadingComponent})
      },
      {
        "path": "/businessCreate/clientEscrowSave",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__businessCreate__clientEscrowSave__index' */'@/pages/businessCreate/clientEscrowSave/index.js'), loading: LoadingComponent})
      },
      {
        "path": "/businessCreate/deliveryOrder",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__businessCreate__deliveryOrder__index' */'@/pages/businessCreate/deliveryOrder/index.js'), loading: LoadingComponent})
      },
      {
        "path": "/businessCreate/escrowWorkOut",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__businessCreate__escrowWorkOut__index' */'@/pages/businessCreate/escrowWorkOut/index.js'), loading: LoadingComponent})
      },
      {
        "path": "/businessCreate/materialLssuanceOrder",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__businessCreate__materialLssuanceOrder__index' */'@/pages/businessCreate/materialLssuanceOrder/index.js'), loading: LoadingComponent})
      },
      {
        "path": "/businessCreate/moduleInstorage",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__businessCreate__moduleInstorage__index' */'@/pages/businessCreate/moduleInstorage/index.js'), loading: LoadingComponent})
      },
      {
        "path": "/businessCreate/moduleReturn",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__businessCreate__moduleReturn__index' */'@/pages/businessCreate/moduleReturn/index.js'), loading: LoadingComponent})
      },
      {
        "path": "/businessCreate/moduleSheet",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__businessCreate__moduleSheet__index' */'@/pages/businessCreate/moduleSheet/index.js'), loading: LoadingComponent})
      },
      {
        "path": "/businessCreate/rentalEquipment",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__businessCreate__rentalEquipment__index' */'@/pages/businessCreate/rentalEquipment/index.js'), loading: LoadingComponent})
      },
      {
        "path": "/businessCreate/sendRepairInvoice",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__businessCreate__sendRepairInvoice__index' */'@/pages/businessCreate/sendRepairInvoice/index.js'), loading: LoadingComponent})
      },
      {
        "path": "/businessCreate/spareDispatch",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__businessCreate__spareDispatch__index' */'@/pages/businessCreate/spareDispatch/index.js'), loading: LoadingComponent})
      },
      {
        "path": "/businessCreate/spareOutbound",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__businessCreate__spareOutbound__index' */'@/pages/businessCreate/spareOutbound/index.js'), loading: LoadingComponent})
      },
      {
        "path": "/businessCreate/sparePartReturnMaintain",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__businessCreate__sparePartReturnMaintain__index' */'@/pages/businessCreate/sparePartReturnMaintain/index.js'), loading: LoadingComponent})
      },
      {
        "path": "/businessCreate/sparePartSave",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__businessCreate__sparePartSave__index' */'@/pages/businessCreate/sparePartSave/index.js'), loading: LoadingComponent})
      },
      {
        "path": "/businessCreate/sparePartStockAdjust",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__businessCreate__sparePartStockAdjust__index' */'@/pages/businessCreate/sparePartStockAdjust/index.js'), loading: LoadingComponent})
      },
      {
        "path": "/businessCreate/sparePartSupply",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__businessCreate__sparePartSupply__index' */'@/pages/businessCreate/sparePartSupply/index.js'), loading: LoadingComponent})
      },
      {
        "path": "/businessCreate/spareRequisition",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__businessCreate__spareRequisition__index' */'@/pages/businessCreate/spareRequisition/index.js'), loading: LoadingComponent})
      },
      {
        "path": "/businessDetails",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__businessDetails__index' */'@/pages/businessDetails/index.js'), loading: LoadingComponent})
      },
      {
        "path": "/change",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__change__index' */'@/pages/change/index.js'), loading: LoadingComponent})
      },
      {
        "path": "/customerdetails",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__customerdetails__index' */'@/pages/customerdetails/index.js'), loading: LoadingComponent})
      },
      {
        "path": "/deliveryList",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__deliveryList__index' */'@/pages/deliveryList/index.js'), loading: LoadingComponent})
      },
      {
        "path": "/home",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__home__index' */'@/pages/home/index.js'), loading: LoadingComponent})
      },
      {
        "path": "/inStorage",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__inStorage__index' */'@/pages/inStorage/index.js'), loading: LoadingComponent})
      },
      {
        "path": "/logdetails",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__logdetails__index' */'@/pages/logdetails/index.js'), loading: LoadingComponent})
      },
      {
        "path": "/materialInfoDetails",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__materialInfoDetails__index' */'@/pages/materialInfoDetails/index.js'), loading: LoadingComponent})
      },
      {
        "path": "/monitoring/dataCenter",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__monitoring__dataCenter__index' */'@/pages/monitoring/dataCenter/index.js'), loading: LoadingComponent})
      },
      {
        "path": "/outStorage",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__outStorage__index' */'@/pages/outStorage/index.js'), loading: LoadingComponent})
      },
      {
        "path": "/permissions",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__permissions__index' */'@/pages/permissions/index.js'), loading: LoadingComponent})
      },
      {
        "path": "/seatDetails",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__seatDetails__index' */'@/pages/seatDetails/index.js'), loading: LoadingComponent})
      },
      {
        "path": "/stockInquirydetails",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__stockInquirydetails__index' */'@/pages/stockInquirydetails/index.js'), loading: LoadingComponent})
      },
      {
        "path": "/storage/businessHandle/audit",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__storage__businessHandle__audit__index' */'@/pages/storage/businessHandle/audit/index.js'), loading: LoadingComponent})
      },
      {
        "path": "/storage/businessHandle/change",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__storage__businessHandle__change__index' */'@/pages/storage/businessHandle/change/index.js'), loading: LoadingComponent})
      },
      {
        "path": "/storage/businessHandle/todo",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__storage__businessHandle__todo__index' */'@/pages/storage/businessHandle/todo/index.js'), loading: LoadingComponent})
      },
      {
        "path": "/storage/businessQuery",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__storage__businessQuery__index' */'@/pages/storage/businessQuery/index.js'), loading: LoadingComponent})
      },
      {
        "path": "/storage/demandSupply",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__storage__demandSupply__index' */'@/pages/storage/demandSupply/index.js'), loading: LoadingComponent})
      },
      {
        "path": "/storage/inventorylog",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__storage__inventorylog__index' */'@/pages/storage/inventorylog/index.js'), loading: LoadingComponent})
      },
      {
        "path": "/storage/movingAccount",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__storage__movingAccount__index' */'@/pages/storage/movingAccount/index.js'), loading: LoadingComponent})
      },
      {
        "path": "/storage/stockInquiry",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__storage__stockInquiry__index' */'@/pages/storage/stockInquiry/index.js'), loading: LoadingComponent})
      },
      {
        "path": "/suppliersdetails",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__suppliersdetails__index' */'@/pages/suppliersdetails/index.js'), loading: LoadingComponent})
      },
      {
        "path": "/systemManage/DepartmentManage",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__systemManage__DepartmentManage__index' */'@/pages/systemManage/DepartmentManage/index.js'), loading: LoadingComponent})
      },
      {
        "path": "/systemManage/accountmanagement",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__systemManage__accountmanagement__index' */'@/pages/systemManage/accountmanagement/index.js'), loading: LoadingComponent})
      },
      {
        "path": "/systemManage/companyManage",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__systemManage__companyManage__index' */'@/pages/systemManage/companyManage/index.js'), loading: LoadingComponent})
      },
      {
        "path": "/systemManage/materialcompany",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__systemManage__materialcompany__index' */'@/pages/systemManage/materialcompany/index.js'), loading: LoadingComponent})
      },
      {
        "path": "/systemManage/resourceManagement",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__systemManage__resourceManagement__index' */'@/pages/systemManage/resourceManagement/index.js'), loading: LoadingComponent})
      },
      {
        "path": "/systemManage/roleManagement",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__systemManage__roleManagement__index' */'@/pages/systemManage/roleManagement/index.js'), loading: LoadingComponent})
      },
      {
        "path": "/todo",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__todo__index' */'@/pages/todo/index.js'), loading: LoadingComponent})
      },
      {
        "path": "/warehouseData/bills",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__warehouseData__bills__index' */'@/pages/warehouseData/bills/index.js'), loading: LoadingComponent})
      },
      {
        "path": "/warehouseData/customerinfo",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__warehouseData__customerinfo__index' */'@/pages/warehouseData/customerinfo/index.js'), loading: LoadingComponent})
      },
      {
        "path": "/warehouseData/materialInfo",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__warehouseData__materialInfo__index' */'@/pages/warehouseData/materialInfo/index.js'), loading: LoadingComponent})
      },
      {
        "path": "/warehouseData/materialSeat",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__warehouseData__materialSeat__index' */'@/pages/warehouseData/materialSeat/index.js'), loading: LoadingComponent})
      },
      {
        "path": "/warehouseData/outPutlibrary",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__warehouseData__outPutlibrary__index' */'@/pages/warehouseData/outPutlibrary/index.js'), loading: LoadingComponent})
      },
      {
        "path": "/warehouseData/seatInfo",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__warehouseData__seatInfo__index' */'@/pages/warehouseData/seatInfo/index.js'), loading: LoadingComponent})
      },
      {
        "path": "/warehouseData/supplierinformation",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__warehouseData__supplierinformation__index' */'@/pages/warehouseData/supplierinformation/index.js'), loading: LoadingComponent})
      },
      {
        "path": "/warehouseData/warehouseInfo",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__warehouseData__warehouseInfo__index' */'@/pages/warehouseData/warehouseInfo/index.js'), loading: LoadingComponent})
      },
      {
        "path": "/warehouseData/warehousekeeper",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__warehouseData__warehousekeeper__index' */'@/pages/warehouseData/warehousekeeper/index.js'), loading: LoadingComponent})
      },
      {
        "path": "/warehouseDetails",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__warehouseDetails__index' */'@/pages/warehouseDetails/index.js'), loading: LoadingComponent})
      },
      {
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__404' */'@/pages/404.js'), loading: LoadingComponent})
      }
    ]
  }
];

  // allow user to extend routes
  plugin.applyPlugins({
    key: 'patchRoutes',
    type: ApplyPluginsType.event,
    args: { routes },
  });

  return routes;
}
